
<div class="stage-statistics-wrapper" :type="type">
	<div class="stage-statistics">
		<div class="stage-name">
			{{ name }}
		</div>
		<div v-if="statusText && statusText !== ''" class="stage-status-text">
			{{ statusText }}
		</div>
	</div>
	<div class="stage-number">
		{{ number }}
	</div>
</div>
